export { default } from './HotspotSmall';
